import { Route, Routes } from '@angular/router';
import { TabConfig } from '../../_core/models/tab-config/tab-config.interface';

const GOVERNANCE_TABS: TabConfig[] = [
    {
        path: 'cost-per-head',
        title: 'Cost per Head',
        loadTabComponent: () => import('./cost-per-head/cost-per-head.component')
            .then((c) => c.CostPerHeadComponent)
    },
    {
        path: 'cost-variance',
        title: 'Cost Variance',
        loadTabComponent: () => import('./cost-variance/cost-variance.component')
            .then((c) => c.CostVarianceComponent),
    },
    {
        path: 'cash-reserves',
        title: 'Cash Reserves',
        loadTabComponent: () => import('./cash-reserves/cash-reserves.component')
            .then((c) => c.CashReservesComponent),
    },
];

// const COMPLIANCE_TABS: TabConfig[] = [
//     {
//         path: 'compliance-rate',
//         title: 'Compliance Rate',
//     },
//     {
//         path: 'risk-mitigation',
//         title: 'Risk Mitigation',
//     },
//     {
//         path: 'customer-escalations',
//         title: 'Customer Escalations',
//     },
//     {
//         path: 'open-employee-issues',
//         title: 'Open Employee Issues',
//     },
//     {
//         path: 'stakeholder-feedback',
//         title: 'Stakeholder Feedback',
//     },
// ];

const GROWTH_TABS: TabConfig[] = [
    {
        path: 'open-positions',
        title: 'Open Positions',
        loadTabComponent: () => import('./growth/open-positions/open-positions.component')
            .then((c) => c.OpenPositionsComponent),
    },
    {
        path: 'retention-rate',
        title: 'Retention Rate',
        loadTabComponent: () => import('./growth/retention-rate/retention-rate.component')
            .then((c) => c.RetentionRateComponent),
    },
    {
        path: 'interviewer-efficiency',
        title: 'Interviewer Efficiency',
        loadTabComponent: () => import('./growth/interviewer-efficiency/interviewer-efficiency.component')
            .then((c) => c.InterviewerEfficiencyComponent),
    }
];

const generateInsightsRoute = (
    { path, title, icon, tabs, showDateFilter }:
        {
            path: string,
            title: string,
            icon: string,
            tabs: TabConfig[],
            showDateFilter?: boolean;
        }): Route => {

    return {
        path: path,
        title: title,
        data: {
            icon: icon,
            tabs: tabs,
            reuse: true,
            module: path.toUpperCase(),
            showDateFilter: !!showDateFilter,
        },
        loadComponent: () => import('./company-insights-tabs.component').then((m) => m.CompanyInsightsTabsComponent),
        children: [
            ...tabs.map((e) => {
                return {
                    path: e.path,
                    title: e.title,
                    data: {
                        reuse: true,
                        apiEndPoint: e.path,
                    },
                    loadComponent: e.loadTabComponent,
                };
            }),
            { path: '**', redirectTo: tabs[0].path }
        ],
    }
}

export const COMPANY_INSIGHTS_ROUTES: Routes = [
    generateInsightsRoute({
        path: 'governance',
        title: 'Governance',
        icon: 'account_balance',
        tabs: GOVERNANCE_TABS,
        showDateFilter: true,
    }),
    generateInsightsRoute({
        path: 'growth',
        title: 'Growth',
        icon: 'bar_chart_4_bars',
        tabs: GROWTH_TABS,
        showDateFilter: true,
    })
];
